import {WeaCheckbox,WeaInput,WeaDatePicker,WeaSelect} from 'ecCom';
import {Button,Row,Col} from 'antd';
import {i18n} from '../public/i18n';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

class Main extends React.Component {
  constructor(props) {
    super(props);
  }
  onBtnClick() {
    this.props.onBtnClick &&　this.props.onBtnClick(this.props.value);
  }
  render() {
    const {props} = this;
    return (
      <div className="hrm-input-btn">
        <Row>
          <Col span={2}><WeaCheckbox {...props}/></Col>
          <Col span={8}>{i18n.label.enableDate()}：<WeaInput {...props}/>{getLabel('386546',"天后")}</Col>
          <Col span={4}><WeaDatePicker {...props}/></Col>
          <Col span={8}>{i18n.label.enableMode()}：<WeaSelect {...props}/></Col>
        </Row>
      </div>
    )
  }
}
export default Main;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/coms/needAutoBtn.js